var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_12443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6678 0H2.21621C1.23652 0 0.444336 0.773438 0.444336 1.72969V22.2656C0.444336 23.2219 1.23652 24 2.21621 24H22.6678C23.6475 24 24.4443 23.2219 24.4443 22.2703V1.72969C24.4443 0.773438 23.6475 0 22.6678 0ZM7.56465 20.4516H4.00215V8.99531H7.56465V20.4516ZM5.7834 7.43438C4.63965 7.43438 3.71621 6.51094 3.71621 5.37187C3.71621 4.23281 4.63965 3.30937 5.7834 3.30937C6.92246 3.30937 7.8459 4.23281 7.8459 5.37187C7.8459 6.50625 6.92246 7.43438 5.7834 7.43438ZM20.8959 20.4516H17.3381V14.8828C17.3381 13.5562 17.3146 11.8453 15.4865 11.8453C13.635 11.8453 13.3537 13.2937 13.3537 14.7891V20.4516H9.80059V8.99531H13.2131V10.5609H13.26C13.7334 9.66094 14.8959 8.70938 16.6256 8.70938C20.2303 8.70938 20.8959 11.0813 20.8959 14.1656V20.4516Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_12443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.444336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e6a3ee6c1e0d8905da80af649849e7aa.svg";
export { ForwardRef as ReactComponent };